// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"0e916e41","52":"7f473cbf","157":"3adfba82","317":"ea80a435","574":"1bc16331","678":"77c2aadc","695":"70eb63e4","872":"1d290acf","956":"df13a06d"}[chunkId] + ".css";
};